import * as Yup from 'yup';
import { ValidFormData, FormInputData } from 'hooks/useTypedForm';

export const formConstants = {
  notes: {
    id: 'notes' as const,
    label: 'Notes',
  },
  shared: {
    id: 'shared' as const,
    label: 'Visibility',
  },
} as const;

export const validationSchema = Yup.object({
  [formConstants.notes.id]: Yup.string().nullable(),
});

export type RFQCartFormValidData = ValidFormData<typeof validationSchema>;
export type RFQCartFormInputData = FormInputData<typeof validationSchema>;
